import type { SpotlightProps } from '@atlaskit/onboarding/types';

export const children = (value: SpotlightProps['children']): SpotlightProps['children'] => {
	return value;
};
